import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Program_language = () => {
  const location = useLocation();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 언어 톡톡`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/program_learning">두뇌 톡톡</a>
              </li>
              <li>
                <a href="/program_language" className="sel">
                  언어 톡톡
                </a>
              </li>
              <li>
                <a href="/program_inquiry">탐구(사회/역사)</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="program_language process">
          <div className="sect process01 language01">
            <div className="wrap">
              <div className="tit init">
                술술 읽고 쏙쏙 이해하는
                <br />
                언어 감수성의 힘을 키워주는
                <br />
                <span>언어 톡톡 프로그램</span>
              </div>
              <div className="img">
                <img
                  src="../custom-resources/img/img_process_language01_img_ver2024.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect process02 language02">
            <div className="wrap">
              <div className="tit init">
                읽기 능력은 모든 학습에 <br />
                필수적인 기초 학습 도구입니다.
              </div>
              <div className="txt init">
                <p>
                  아소비 언어 톡톡 프로그램은 언어 교육의 핵심 도구인{" "}
                  <br className="mo-view" />
                  읽기능력을 바탕으로 <br className="pc-view" />
                  <span className="neon init">글을 빠르게 읽고, </span>
                  <br className="mo-view" />
                  <span className="neon init">
                    쉽게 이해하는 읽기 유창성을 키우기
                  </span>{" "}
                  위한 <br className="mo-view" />
                  언어 훈련 프로그램입니다.
                </p>
              </div>
            </div>
          </div>
          <div className="sect process03 language03">
            <div className="wrap">
              <div className="tit init">
                빠르게 읽고 쉽게 이해하기 훈련인 <br className="mo-view" />
                명명하기(RAN),
                <br className="pc-view" />
                그림을 보고 신속하게 <br className="mo-view" />
                생각을 떠올려 긴 문장으로 말하기 및<br />
                긴 문장 빠르게 읽기 훈련은 <br className="mo-view" />
                초등 학습의 기본이 됩니다.
              </div>
            </div>
          </div>
          <div className="sect process04 language04">
            <div className="wrap">
              <div className="lang">
                <div className="init">
                  <div className="image type1">
                    <img
                      src="../custom-resources/img/img_process_language04_icon01.png"
                      alt=""
                    />
                  </div>
                  <div className="desc desc01">
                    <div className="tit">명명하기</div>
                    <div className="txt">
                      빠른 자동 이름대기(RAN) 읽기 훈련법을{" "}
                      <br className="mo-view" />
                      아소비만의 방법으로
                      <br className="pc-view" />
                      <span>
                        아동의 발달 수준에 맞게 <br className="mo-view" />
                        응용하여 만든 활동
                      </span>
                      으로
                      <br className="pc-view" />
                      그림을 순서대로 보고 <br className="mo-view" />
                      낱말을 떠올려 말하는 언어 훈련 프로그램입니다.
                    </div>
                  </div>
                </div>
                <div className="init">
                  <div className="image type1">
                    <img
                      src="../custom-resources/img/img_process_language04_icon02.png"
                      alt=""
                    />
                  </div>
                  <div className="desc desc02">
                    <div className="tit">말하기</div>
                    <div className="txt">
                      다양한 그림을 눈으로 보고, <br className="mo-view" />
                      신속하게 떠오른 생각을
                      <br />
                      <span>
                        1어절~4어절의 문장의 단계로 말해 보는
                        <br className="mo-view" />
                      </span>{" "}
                      언어 훈련 프로그램입니다.
                    </div>
                  </div>
                </div>
                <div className="init">
                  <div className="image type1">
                    <img
                      src="../custom-resources/img/img_process_language04_icon03.png"
                      alt=""
                    />
                  </div>
                  <div className="desc desc03">
                    <div className="tit">읽기</div>
                    <div className="txt">
                      단계별로 구성된 <span>3어절에서 5어절의 문장을 읽고</span>
                      <br /> 의미하는 내용을
                      <br className="pc-view" />
                      <span>빠르게 이해</span>하는 <br className="mo-view" />
                      읽기 언어 훈련 프로그램입니다.
                    </div>
                  </div>
                </div>
                <div className="init">
                  <div className="image type1">
                    <img
                      src="../custom-resources/img/img_process_language04_icon04.png"
                      alt=""
                    />
                  </div>
                  <div className="desc desc04">
                    <div className="tit">스스로 확인해요</div>
                    <div className="txt">
                      읽기 유창성을{" "}
                      <span>스스로 평가하고 확인할 수 있는 활동</span>입니다.
                      <br />
                      스스로 읽어 본 회수를 점검하고, <br className="mo-view" />
                      정확하고 빠르게 읽었는지와
                      <br />
                      또박 읽었는지를 평가하는 활동입니다.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sect process05 language05">
            <div className="wrap">
              <div className="tit init">
                아소비에서만 만날 수 있는 언어 톡톡 프로그램
              </div>
              <div className="txt init">
                특허 받은 아소비 한글, 언어 톡톡 프로그램,{" "}
                <br className="mo-view" />
                아소비 문해력 프로그램
                <br />이 3가지라면 아이는 술술 읽고 척척 쓰게 됩니다.
              </div>
              <a href="/process_grow" className="prcs_tit init green">
                그로우 과정
              </a>
              <div className="img init">
                <img
                  src="../custom-resources/img/img_process_grow05_img01_2024.png"
                  alt=""
                />
              </div>
              <a href="/process_master" className="prcs_tit init pink">
                마스터 과정
              </a>
              <div className="img init">
                <img
                  src="../custom-resources/img/img_process_master05_img01_2024.png"
                  alt=""
                />
              </div>
              <a
                href="/program_elementary1"
                className="prcs_tit init blue"
              >
                초등 과정
              </a>
              <div className="img init">
                <img
                  src="../custom-resources/img/img_process_elementary01_img10_2024.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Program_language;
